import { jsx as c } from "react/jsx-runtime";
import { SvgIcon as o } from "../SvgIcon.js";
const s = (e) => /* @__PURE__ */ c(o, { ...e, children: /* @__PURE__ */ c(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.399 2A1.6 1.6 0 0 1 18 3.601V16.4c0 .88-.721 1.601-1.601 1.601H3.6C2.721 18 2 17.279 2 16.399V3.6C2 2.721 2.721 2 3.601 2H16.4Zm-.358 8.712-1.52-5.037-2.33-.807-.343.998 1.83.628.777 2.569a2.74 2.74 0 0 0-1.01-.19c-.954 0-1.797.493-2.307 1.244h-2.33a2.774 2.774 0 0 0-2.296-1.234c-.355 0-.7.068-1.01.191l.777-2.569 1.83-.628-.344-.998-2.33.808-1.53 5.025c-.111.303-.178.628-.178.964 0 1.548 1.243 2.804 2.774 2.804 1.53 0 2.773-1.256 2.773-2.804 0-.168-.022-.336-.044-.505h1.475a3.57 3.57 0 0 0-.044.505c0 1.548 1.242 2.804 2.773 2.804 1.531 0 2.774-1.256 2.774-2.804a2.56 2.56 0 0 0-.167-.964Zm-9.54 2.714c-.954 0-1.73-.785-1.73-1.75 0-.964.776-1.75 1.73-1.75s1.73.786 1.73 1.75c-.01.965-.787 1.75-1.73 1.75Zm6.933 0c-.954 0-1.73-.785-1.73-1.75 0-.964.776-1.75 1.73-1.75s1.73.786 1.73 1.75c-.01.965-.776 1.75-1.73 1.75Z"
  }
) });
export {
  s as Glasses2
};
//# sourceMappingURL=Glasses2.js.map
